import storeFactory from '@/helpers/storeFactory'
import apolloProvider from '@/services/apolloProvider.service'
import gql from 'graphql-tag'
import paramsDistrict from '@/common/paramsDistrict'

export default storeFactory({
  model: {
    reason_uuid: null,
    district_id: null,
    operation_level_uuid: null,
    title: null,
    comment: null,
    time_start: new Date(),
    location: null,
    basun: null,
    basun_time: null,
    routes: [],
    created: null
  },

  state: {
    fetching: false,
    stops: [],
    selectedUUID: null,
    selectedEventLoaded: false
  },

  getters: {
    selectedEvent(state) {
      return state.data[state.selectedUUID]
    }
  },

  actions: {
    async checkUnhandledDuaMessages({ state }) {
      try {
        await apolloProvider.clients.defaultClient.query({
          query: gql`
            mutation checkUnhandledDuaMessages {
              checkUnhandledDuaMessages {
                updated_count
              }
            }
          `,
          fetchPolicy: 'no-cache'
        })

        const isStatusUnknownLastDuaMessage = Object.values(state.data).some(
          x =>
            x.last_dua_message &&
            x.last_dua_message.body.some(x => x.status === 'Unknown')
        )

        return isStatusUnknownLastDuaMessage
      } catch (err) {
        console.log(err)
        return err
      }
    },

    async selectEvent({ commit, getters, dispatch }, uuid) {
      commit('SET_SELECTED_EVENT_LOADED', false)
      commit('SET_SELECTED_UUID', uuid)
      commit('duaMessage/SET_FORM', {}, { root: true })
      const selectedEvent = getters['selectedEvent']
      const lastTrafficMessage = selectedEvent?.last_traffic_message || null

      const { data } = await apolloProvider.clients.defaultClient.query({
        query: gql`
          query trainDeviation($filter: GetEventInput!) {
            event(filter: $filter) {
              train_deviations {
                event_uuid
                uuid
                type
                train_number
                from
                to
                departure
                places
                arrival
                deviation_type
                checked
                deleted
              }
            }
          }
        `,
        variables: {
          filter: {
            uuid: selectedEvent.uuid
          }
        },
        fetchPolicy: 'no-cache'
      })

      if (lastTrafficMessage && Object.keys(lastTrafficMessage).length) {
        commit(
          'trafficMessage/SET_MODEL',
          Object.assign({}, lastTrafficMessage),
          { root: true }
        )
      } else {
        commit('trafficMessage/resetModel', null, { root: true })
      }
      const lastDuaMessage = selectedEvent?.last_dua_message || null

      const lastSmsMessage = selectedEvent?.last_sms_message || null

      if (lastSmsMessage) {
        lastSmsMessage.trips = lastSmsMessage.trips.map(x => {
          if (!x.data.cancel_sections) {
            const trip = data.event?.train_deviations?.find(
              y => y.uuid === x.trip_uuid
            )
            return {
              ...x,
              data: {
                ...x.data,
                cancel_sections: [
                  {
                    from: trip?.from || null,
                    to: trip?.to || null,
                    dua_cancellation_code: 'ANA027',
                    dua_reference_code: 'ANA075',
                    estimated_time_at_location: null,
                    departure: trip.departure
                      ? +new Date(trip.departure)
                      : null,
                    arrival: trip.arrival ? +new Date(trip.arrival) : null,
                    index: 0
                  }
                ]
              }
            }
          }
          return x
        })
        commit(
          'smsMessage/SET_MODEL',
          Object.assign({}, selectedEvent.last_sms_message),
          { root: true }
        )
        dispatch('smsMessage/setForm', {}, { root: true })
      }

      if (lastDuaMessage) {
        lastDuaMessage.body = lastDuaMessage.body.map(x => {
          if (!x.data.cancel_sections) {
            const trip = data.event?.train_deviations?.find(
              y => y.uuid === x.trip_uuid
            )
            return {
              ...x,
              data: {
                ...x.data,
                cancel_sections: [
                  {
                    from: trip?.from || null,
                    to: trip?.to || null,
                    dua_cancellation_code: 'ANA027',
                    dua_reference_code: 'ANA075',
                    estimated_time_at_location: null,
                    departure: trip.departure
                      ? +new Date(trip.departure)
                      : null,
                    arrival: trip.arrival ? +new Date(trip.arrival) : null,
                    index: 0
                  }
                ]
              }
            }
          }
          return x
        })
        commit(
          'duaMessage/SET_MODEL',
          Object.assign({}, selectedEvent.last_dua_message),
          { root: true }
        )
        dispatch('duaMessage/setForm', {}, { root: true })
      }
    },

    unSelectEvent({ state, commit, rootState }) {
      if (state.selectedUUID) {
        window.history.replaceState(
          {},
          document.title,
          `/${paramsDistrict(rootState.app.selectedDistrictId)}/event`
        )
      }
      commit('SET_SELECTED_EVENT_LOADED', false)
      commit('SET_SELECTED_UUID', null)
      commit('trafficMessage/resetModel', null, { root: true })
      commit('duaMessage/resetModel', null, { root: true })
      commit('duaMessage/SET_FORM', {}, { root: true })
    },

    async fetchStops({ commit, rootState }) {
      try {
        const { data } = await apolloProvider.clients.defaultClient.query({
          query: gql`
            query stops($filter: GetStopsInput) {
              stops(filter: $filter) {
                stop_name
                short_name
              }
            }
          `,
          variables: {
            filter: {
              district_id: rootState.app.selectedDistrictId
            }
          },
          fetchPolicy: 'no-cache'
        })

        if (data.stops) {
          commit('SET_STOPS', data.stops)
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
})
